module.exports = __webpack_public_path__ + "static/media/808KnobLabel--shuffle.724af14e.svg";